<template>
  <div>
    <b-modal id="bv-modal-transfer" title="Para qual Departamento/Operador deseja transferir?" centered hide-footer>
      <b-row class="justify-content-md-center">

        <b-col cols="12" md="7">
          <v-select
            label="text"
            :options="queues"
            :searchable="false"
            v-model="selectedFila">
            <template #header>
              <div style="opacity: 1">Departamento</div>
            </template>
          </v-select>
        </b-col>
      </b-row>

      <b-row v-if="exten.length > 0" class="justify-content-md-center mt-3">
        <b-col cols="12" md="7">
          <v-select
            label="name"
            :options="exten"
            v-model="selectedRamal">
            <template #header>
              <div style="opacity: 1">Operador</div>
            </template>
          </v-select>
        </b-col>
      </b-row>

      <b-row class="justify-content-md-center mt-3" v-else>
        <b-col cols="12" md="7">
          <v-select
            v-model="selectedNotRamal">
            <template #header>
              <div style="opacity: 1">Operadores</div>
            </template>
            <span slot="no-options">Nenhum operador disponível</span>
          </v-select>
        </b-col>
      </b-row>

      <b-row class="mt-3 pad">
        <b-col></b-col>
        <b-col cols="12" md="auto">
          <b-button @click="$bvModal.hide('bv-modal-transfer')">CANCELAR</b-button>
          <b-button variant="primary" @click="sendTransfer">TRANSFERIR</b-button>
        </b-col>
      </b-row>
      <b-toast id="my-toast" variant="warning" solid>
        <template #toast-title>
          <div class="d-flex flex-grow-1 align-items-baseline">
            <strong><b-icon icon="exclamation-triangle" class="mr-2" style="color: #91560a; width: 18px; height: 18px;"></b-icon></strong>
            <strong class="mr-auto mt-2" style="font-size: 16px">Atenção</strong>
          </div>
        </template>
        Você precisa selecionar pelo menos o Departamento
      </b-toast>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import axios from 'axios';

export default {
  name: "ModalTransferencia",
  data: () => ({
    queues: [],
    operators: [],
    selectedFila: { value: null, text: 'Selecione' },
    selectedRamal: null,
    selectedNotRamal: 'Nenhum operador disponível',
    options: [],
    exten: [],
  }),
  watch:{
    gettransfData(){
      this.queues = this.gettransfData.fila;
    },
    async selectedFila(){
      if(this.selectedFila == null || typeof this.selectedFila == 'object') return;
      
      const response = await axios.get(`ramaisFila/${this.selectedFila}`);
      const ramais = response.data;
      this.exten = [];

      this.gettransfData.ramal.forEach(el => {
        const value = el.replace(/\D/g, "");

        if( ramais[value] && user.getExtension() != value){
          this.exten.push({
            extension_line: ramais[value].extension_line,
            name: ramais[value].name
          })
        }
      });
    }
  },
  computed: {
    ...mapGetters(['gettransfData']),
  },
  methods: {
    ...mapMutations(['transfProcess', 'transfCurrentConversa']),
    openModal() {
      this.$bvModal.show('bv-modal-transfer');
      this.transfProcess();
    },
    async sendTransfer() {
      if(!this.selectedFila || typeof this.selectedFila == 'object'){
        Swal.fire({
          title: "Você não selecionou nenhuma fila",
          text: "Selecione a fila para qual deseja transferir",
          type: 'info',
          confirmButtonText: "Ok"
			  });
        return;
      }

      if(this.selectedRamal?.extension_line && this.selectedRamal?.name){
        return this.transfCurrentConversa(
          {
            destination: {
              id: this.selectedRamal.extension_line, 
              name: this.selectedRamal.name,
              nameFila: this.selectedFila
            }, 
            origin: {
              id: user.getExtension(),
              name: user.getName()
            },
            type: 'operator'
          }
        );
      }

      if(this.selectedFila && typeof this.selectedFila !== undefined){
        return this.transfCurrentConversa(
          {
            destination: {
              name: this.selectedFila
            },
            origin: {
              id: user.getExtension(),
              name: user.getName()
            },
            type: 'queue',
          }
        );
      }

      this.selectedFila = { value: null, text: 'Selecione' };
      this.selectedRamal = null;
    }
  },
}
</script>

<style scoped>
.pad{
  padding:1em;
}
</style>